<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Photography",
    "pageDesc":"Get professional photography that matches your brand style and resonates with your audience whether food, products or corporate imagery.",
    "mantra":"Photography that |supports branding.",
    "mantraDesc":"Capture real images of your products, team, official events, office spaces and use it later as a marketing asset that carries your brand true essence.",
    "sec1":"Express your ideas better with custom imagery.",
    "sec1Items":{
      "1":{
        "title":"Product photography",
        "desc":"Promote your store new arrivals or draw the attention towards a new product launch."
      },
      "2":{
        "title":"Food photography",
        "desc":"Combined with food styling, we take shots that makes your perfect dishes standout."
      },
      "3":{
        "title":"Corporate photography",
        "desc":"Document your company important events, moments and showcase your culture."
      },
      "4":{
        "title":"Social media photography",
        "desc":"Combining real images with graphics to create visuals that makes people click."
      },
      "5":{
        "title":"Advertorial photography",
        "desc":"Taking shots to complete the whole campaign theme with different styles and layouts."
      }
    },
    "sec2":"Creating your own brand album.",
    "sec2Items":{
      "1":{
        "title":"Moodboards",
        "desc":"Collecting photos from different resources to create a harmonized feeling that resonates with the brand."
      },
      "2":{
        "title":"Shooting",
        "desc":"Whether indoor or outdoor, we bring out set to your location and create scenarios that best communicates the messages needed. "
      },
      "3":{
        "title":"Photography style guide",
        "desc":"To ensure consistent feeling in all photographs, the guide is created to outline what kind of content we shoot? How we edit photos and why."
      }
    },
    "cta":"Capture your brand <br> essence."
  },
  "ar": {
    "pageTitle":"التصوير",
    "pageDesc":"احصل على صور فوتوغرافية  مميزة تتماشى مع علامتك التجارية وتلفت أنظار جمهورك سواء كنت تقدم طعامًا أو منتجات أو صور للشركة.",
    "mantra":"ادعم علامتك التجارية |من خلال التصوير.",
    "mantraDesc":"التقط صورًا حقيقية لمنتجاتك وفريقك وشكل شركتك وسجل الأحداث الرسمية التي تمر بها واستخدمها لاحقًا في التسويق وبهذا تبرز جوهر العلامة التجارية الحقيقي.",
    "sec1":"عبر عن أفكارك بصور مخصصة.",
    "sec1Items":{
      "1":{
        "title":"تصوير المنتج",
        "desc":"روج للمنتجات التي وردت إليك حديثًا أو اجذب الانتباه عند إطلاق منتج جديد من خلال الصور."
      },
      "2":{
        "title":"تصوير الأطعمة",
        "desc":"اجعل تصميمات الأطعمة  التي تقدمها لجمهورك حقيقية، وقدم لهم الأطباق بصورتها المثالية."
      },
      "3":{
        "title":"تصوير الشركات",
        "desc":"وثق الأحداث المهمة والفعاليات الرسمية وجميع اللحظات والاحتفالات ووضح الثقافة التي تعتمد عليها شركتك من خلال الصور."
      },
      "4":{
        "title":"تصوير لوسائل التواصل الاجتماعي",
        "desc":"اجمع بين الصور الحقيقية والجرافيك لإنشاء محتوى بصري يلفت انتباه الجمهور من اللحظة الأولي."
      },
      "5":{
        "title":"تصوير للإعلانات",
        "desc":"استكمل حملتك الإعلانية من خلال صور تتكامل مع النمط وتخطيطات التي تسير عليه الحملة."
      }
    },
    "sec2":"احصل على ألبوم لعلامتك التجارية.",
    "sec2Items":{
      "1":{
        "title":"مود بورد",
        "desc":"جمع الصور من المصادر المختلفة لتخلق شعور متناغم ينعكس على العلامة التجارية."
      },
      "2":{
        "title":"اللقطات",
        "desc":"سواء تنشر رسالتك داخليًا أو خارجيًا، فإننا نتفهم جيدًّا موقعك ونضع جميع السيناريوهات المحتملة لتصل رسالتك على أكمل وجه."
      },
      "3":{
        "title":"إرشادات التصوير",
        "desc":"لنضمن وجود انطباع ثابت في جميع الصور المقدمة إليك، نقدم في البداية دليل ليرشدنا على نوع المحتوى  واللقطات التي يجب الحصول عليها، وكيف نقوم بتحرير الصور ولماذا؟"
      }
    },
    "cta":"استحوذ على عيون عملائك <br> بصور حقيقية."
  }
}
</i18n>
